import { render, staticRenderFns } from "./CompleteAccount.vue?vue&type=template&id=6c30030a"
import script from "./CompleteAccount.vue?vue&type=script&lang=js"
export * from "./CompleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports